import {
  CreateBusinessUnitV2Command,
  CreateBusinessUnitV2CommandInput,
  DeleteBusinessUnitCommand,
  DeleteBusinessUnitCommandInput,
  GetBusinessUnitByProgramV2Command,
  GetBusinessUnitByProgramV2CommandInput,
  ListBusinessUnitsV2Command,
  ListBusinessUnitsV2CommandInput,
  UpdateBusinessUnitV2Command,
  UpdateBusinessUnitV2CommandInput,
} from '@amzn/gbsa-orbit-typescript-client';
import { apiOrbitClient } from 'src/data/api/apiOrbitClient';

export const businessUnitService = {
  getAll: (data: ListBusinessUnitsV2CommandInput) => {
    return apiOrbitClient.send(new ListBusinessUnitsV2Command(data));
  },

  get: (data: GetBusinessUnitByProgramV2CommandInput) => {
    return apiOrbitClient.send(new GetBusinessUnitByProgramV2Command(data));
  },
  update: (data: UpdateBusinessUnitV2CommandInput) => {
    return apiOrbitClient.send(new UpdateBusinessUnitV2Command(data));
  },

  delete: (data: DeleteBusinessUnitCommandInput) => {
    return apiOrbitClient.send(new DeleteBusinessUnitCommand(data));
  },

  create: (data: CreateBusinessUnitV2CommandInput) => {
    return apiOrbitClient.send(new CreateBusinessUnitV2Command(data));
  },
};
